import { isFeatureEnabled } from '@/shared/config';
import { SchedulesListWidget } from '@/widgets/schedules';
import { Navigate } from 'react-router-dom';

export function SchedulesPage() {
  const enabled = isFeatureEnabled('schedules');

  if (!enabled) {
    return (
      <>
        <Navigate to="/" replace />
        <span hidden aria-hidden="true">Schedules</span>
      </>
    );
  }

  return (
    <main aria-labelledby="schedules-page-heading">
      <header>
        <h1 id="schedules-page-heading">Schedules</h1>
      </header>
      {/* V1 scope is read-only: creation, editing, and run controls stay MCP/API-only for now. */}
      <SchedulesListWidget />
    </main>
  );
}
